module.exports = __webpack_public_path__ + "img/DE00629.cd0afcc8.png";